import React from "react";
import { Link } from "react-router-dom";
import { X, Trash2, Plus, Minus } from "lucide-react";
import { useCart } from "../lib/cart";

export default function CartDrawer() {
  const { items, open, setOpen, remove, updateQty, subtotal, discount, discountAmount, total, setDiscount } = useCart();

  return (
    <>
      <div
        className={`fixed inset-0 bg-black/40 z-[60] transition-opacity duration-300 ${open ? "opacity-100" : "opacity-0 pointer-events-none"}`}
        onClick={() => setOpen(false)}
        aria-hidden="true"
      />
      <aside
        data-testid="cart-drawer"
        className={`fixed top-0 right-0 h-full w-full sm:w-[420px] bg-brand-bg z-[70] shadow-2xl flex flex-col transition-transform duration-300 ${open ? "translate-x-0" : "translate-x-full"}`}
      >
        <div className="flex items-center justify-between px-6 py-5 border-b border-brand-line">
          <div className="font-serif text-2xl">Your Bag</div>
          <button onClick={() => setOpen(false)} aria-label="Close cart" data-testid="close-cart-btn">
            <X size={22} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-6 py-6">
          {items.length === 0 && (
            <div className="text-center py-20 text-brand-muted">
              <div className="font-serif text-xl text-brand-ink">Your bag is empty</div>
              <p className="text-sm mt-2">Discover our newest Ankara pieces.</p>
              <Link
                to="/shop"
                onClick={() => setOpen(false)}
                data-testid="empty-cart-shop-link"
                className="btn-primary mt-6"
              >
                Shop now
              </Link>
            </div>
          )}
          {items.map((item) => (
            <div key={`${item.product_id}-${item.size}`} className="flex gap-4 py-5 border-b border-brand-line" data-testid={`cart-item-${item.product_id}`}>
              <img src={item.image} alt={item.name} className="w-20 h-24 object-cover" />
              <div className="flex-1">
                <div className="font-medium text-sm">{item.name}</div>
                <div className="text-xs text-brand-muted mt-1">Size: {item.size}</div>
                <div className="text-sm mt-2">£{item.price.toFixed(2)}</div>
                <div className="flex items-center gap-3 mt-3">
                  <button onClick={() => updateQty(item.product_id, item.size, item.quantity - 1)} className="border border-brand-line w-7 h-7 flex items-center justify-center hover:bg-brand-bg2"><Minus size={12} /></button>
                  <span className="text-sm" data-testid={`qty-${item.product_id}`}>{item.quantity}</span>
                  <button onClick={() => updateQty(item.product_id, item.size, item.quantity + 1)} className="border border-brand-line w-7 h-7 flex items-center justify-center hover:bg-brand-bg2"><Plus size={12} /></button>
                </div>
              </div>
              <button onClick={() => remove(item.product_id, item.size)} aria-label="Remove" data-testid={`remove-${item.product_id}`} className="text-brand-muted hover:text-brand-accent">
                <Trash2 size={16} />
              </button>
            </div>
          ))}
        </div>

        {items.length > 0 && (
          <div className="px-6 py-6 border-t border-brand-line">
            {discount && (
              <div className="flex items-center justify-between mb-3 text-sm" data-testid="cart-discount">
                <span className="overline text-brand-accent flex items-center gap-2">
                  <span>Code {discount}</span>
                  <button onClick={() => setDiscount("")} className="text-xs underline text-brand-muted hover:text-destructive">remove</button>
                </span>
                <span className="text-brand-accent">−£{discountAmount.toFixed(2)}</span>
              </div>
            )}
            <div className="flex items-center justify-between mb-4">
              <span className="overline">{discount ? "You pay" : "Subtotal"}</span>
              <span className="font-serif text-2xl" data-testid="cart-subtotal">£{(discount ? total : subtotal).toFixed(2)}</span>
            </div>
            <Link
              to="/checkout"
              onClick={() => setOpen(false)}
              data-testid="checkout-link"
              className="btn-primary w-full text-center block"
            >
              Checkout
            </Link>
          </div>
        )}
      </aside>
    </>
  );
}
